import { FilterNames } from '../../constants';
import { IFilterStateHandler, ISelectFilterOption, ISelectFilter } from '../../../shop-ui/components/search-page/interfaces';
import AbstractSelectFilterHandler from '../../../shop-ui/includes/filter-state/AbstractSelectFilterHandler';

export default class BrandFilterHandler extends AbstractSelectFilterHandler implements IFilterStateHandler {
    public createQueryParams = (filter: ISelectFilter, params: object): void => {
        params[FilterNames.BRAND] = filter.options
            .filter(option => option.selected)
            .map(selectedOption => selectedOption.value)
            .sort((option, nextOption) =>
                option.toLowerCase().localeCompare(nextOption.toLowerCase()),
            );
    }

    public resetQueryParams = (params: object): void => {
        params[FilterNames.BRAND] = [];
    }

    public getSelectedOptions = (filter: ISelectFilter): ISelectFilterOption[] => filter.options
        .filter(option => option.selected)
        .sort((option, nextOption) =>
            option.label.toLowerCase().localeCompare(nextOption.label.toLowerCase()),
        );

    public updateSelectedOptions = (filter: ISelectFilter, selectedValues: string[]): void => {
        filter.options = filter.options.map((option: ISelectFilterOption) => {
            option.selected = selectedValues.includes(option.value);

            return option;
        }).sort(
            (option, nextOption) =>
                option.label.toLowerCase().localeCompare(nextOption.label.toLowerCase())
        );
    }
}
